import Alpine from "alpinejs";
import htmx from "htmx.org";
import { renderRcdIcons } from "../core/icons";
import { createRcdThemeState } from "../core/theme";
import { hideRcdPreloaderWhenReady } from "../core/preloader";
import { setupRcdHtmxLifecycle } from "../core/htmx";
import { setupRcdDialogs } from "../core/components/dialog";
import { setupRcdTooltips } from "../core/components/tooltip";
import { setupRcdPopovers } from "../core/components/popover";
import { setupRcdMenus } from "../core/components/menu";
import { setupRcdMultiSelects } from "../core/components/multi-select";
import { setupRcdSearchSelects } from "../core/components/search-select";
import { setupRcdCustomerPickers } from "../core/components/customer-picker";
import { setupRcdPhoneInputs } from "../core/components/phone-input";
import { setupRcdRichTextEditors } from "../core/components/rich-text-editor";
import { setupRcdDateTimeInputs } from "../core/components/date-time-input";
import { setupRcdDropdownKits } from "../core/components/dropdown-kit";
import { setupRcdAvatars } from "../core/components/avatar";
import { setupSupplierEditors } from "../core/components/supplier-editor";
import { setupInquiryAjaxPage, setupInquiryAjaxForms, setupInquiryBulkActions, setupInquiryStackLinks } from "../entries/inquiries";
import { setupWorkspaceSettingsPage } from "../entries/settings";
import { setupCalendarDialogs, setupJobEditor, setupJobStatusPicker, setupJobTabs, setupWorkspaceCalendars } from "../entries/job-workspace";
import { setupInvoiceWorkspace } from "../entries/invoice-workspace";
import { setupQuoteWorkspace } from "../entries/quote-workspace";
import { setupWorkspaceRegisters } from "../entries/workspace-register";
import { setupTimesheetEntries } from "../entries/timesheet-entry";
import { createRcdUiApi, setupRcdSharedComponents, setupRcdUiStore } from "../shared/rcd-ui";

window.Alpine = Alpine;
window.htmx = htmx;

const bootUi = () => {
    renderRcdIcons();
};

const mountUserFeatures = (root = document) => {
    setupRcdSearchSelects(root);
    setupRcdCustomerPickers(root, renderRcdIcons);
    setupInquiryAjaxPage();
    setupInquiryBulkActions();
    setupInquiryAjaxForms();
    setupInquiryStackLinks();
    setupWorkspaceSettingsPage();
    setupJobEditor();
    setupJobTabs();
    setupJobStatusPicker();
    setupWorkspaceCalendars(root);
    setupInvoiceWorkspace();
    setupQuoteWorkspace(root);
    setupWorkspaceRegisters(root);
    setupRcdMultiSelects(root, renderRcdIcons);
    setupCalendarDialogs();
    setupRcdPhoneInputs(root);
    setupRcdRichTextEditors(root);
    setupRcdDateTimeInputs(root);
    setupRcdDropdownKits(root, renderRcdIcons);
    setupTimesheetEntries(root);
    setupRcdAvatars(root);
    setupSupplierEditors(root);
};

window.rcdUser = {
    init(root = document) {
        bootUi();
        mountUserFeatures(root);
        return true;
    }
};

document.addEventListener("DOMContentLoaded", () => {
    setupRcdUiStore(Alpine, bootUi);
    setupRcdDialogs();
    setupRcdTooltips();
    setupRcdPopovers();
    setupRcdMenus();
    setupRcdSharedComponents(Alpine);
    window.rcdUser = {
        ...window.rcdUser,
        ...createRcdUiApi(Alpine)
    };
    Alpine.start();
    window.rcdUser.init();
    hideRcdPreloaderWhenReady();
});

setupRcdHtmxLifecycle((root) => {
    window.rcdUser.init(root);
});
